import { useState, useEffect, useRef } from 'react'
import { useParams } from 'react-router-dom'
import { jwtDecode } from 'jwt-decode'
import axios from 'axios'
import { AddToCalendarButton } from 'add-to-calendar-button-react'
import { FaCalendarPlus, FaCheck } from 'react-icons/fa'
import { IoClose } from 'react-icons/io5'

import { atcb_action } from 'add-to-calendar-button'
import '../styles/GuestDashboard.css'
import BottomNav from '../components/BottomNavGuest'
import LocationSection from '../components/LocationSection'
import LoadingComponent from '../components/LoadingComponent'
import { useLanguage } from '../context/LanguageContext'
import { T } from '../components/Translation'
import PayMe3DSCheckout from '../components/Payme/PayMe3DSCheckout'
  const saleInfo = {
    // --- Backend API Fields ---
    seller_payme_id: process.env.REACT_APP_PAYME_SELLER_ID,
    sale_price: 500,
    currency: "ILS",
    product_name: "Shirt",
    // sale_type: "sale",
    // sale_callback_url: "https://your-domain.com/payment/3ds-callback", // Where 3DS sends result
    // --- Payer/Buyer Details ---
    payerFirstName: "John",
    payerLastName: "Doe",
    payerEmail: "john.doe@example.com",
    payerPhone: "+972501234567",
    // --- Tokenization Details (must match sale_price/currency) ---
    total: {
      amount: { value: '5.00', currency: 'ILS' },
      label: 'Shirt Purchase'
    }
  };
const BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000'

const GuestDashboard = ({
  wifeFirstName,
  husbandFirstName,
  setWifeFirstName,
  setHusbandFirstName,
}) => {
  const { id } = useParams()
  const calendarButtonRef = useRef(null)
  const { language } = useLanguage()

  const [guestData, setGuestData] = useState(null)
  const [eventInfo, setEventInfo] = useState(null)
  const [rsvpStatus, setRsvpStatus] = useState(null)
  const [guestCount, setGuestCount] = useState(1)
  const [confirmedGuestCount, setConfirmedGuestCount] = useState(0) // Track confirmed guest count
  const [showModal, setShowModal] = useState(false)
  const [activeTab, setActiveTab] = useState('rsvp') // Default tab
  const [startDate, setStartDate] = useState(null)
  const [startTime, setStartTime] = useState(null)
  const [showTransport, setShowTransport] = useState(false) // transport modal
  const [transport, setTransport] = useState('none')
  const [saveConfirmed, setSaveConfirmed] = useState(false)
  const [giftAmount, setGiftAmount] = useState('')
  const [giftMessage, setGiftMessage] = useState('')
  const [showPaymentForm, setShowPaymentForm] = useState(false)

  const handleDivClick = (e) => {
    // Find the actual button inside the AddToCalendarButton component
    if (calendarButtonRef.current) {
      console.log(
        'Div clicked, attempting to find button : ',
        calendarButtonRef.current
      )
      const button = calendarButtonRef.current.querySelector(
        'button, [role="button"], add-to-calendar-button'
      )
      console.log('Button found: ', button)
      if (button) {
        const config = {
          name: ` האירוע של ${wifeFirstName}`,
          // name: ` חתונה של ${wifeFirstName}&${husbandFirstName}`,
          location: eventInfo.eventAddress,
          startDate: startDate,
          startTime: startTime,
          endTime: '23:59',
          timeZone: 'Asia/Jerusalem',
          options: ['Google', 'Apple', 'iCal'],
        }
        atcb_action(config, e.currentTarget)
      }
    }
  }

  const handleAddTransport = () => {
    if (transport === 'none') {
      setSaveConfirmed(true)
      setTimeout(() => {
        setSaveConfirmed(false)
        setShowTransport(false)
      }, 2000) // Close modal after 1.5 seconds
    }

    axios
      .post(`${BASE_URL}/guest/transport`, {
        admin_username: guestData.a, // from decoded JWT
        phone_number: guestData.p,
        transport, // 'tlv' | 'herz'
      })
      .then(() => {
        // Show in-modal confirmation
        setSaveConfirmed(true)
        setTimeout(() => {
          setSaveConfirmed(false)
          setShowTransport(false)
        }, 2000) // Close modal after 1.5 seconds
      })
      .catch((err) => {
        console.error('Error saving transport:', err)
        alert(
          language === 'he'
            ? 'שגיאה בשמירת ההעדפה, נסה שוב מאוחר יותר.'
            : 'Error saving preference, please try again later.'
        )
      })
  }

  // New function to handle transport changes
  const handleChangeTransport = () => {
    setShowTransport(true)
  }

  useEffect(() => {
    if (!id) return // defensive
    axios
      .get(`${BASE_URL}/guest/token/${id}`)
      .then(({ data }) => {
        const decoded = jwtDecode(data.token)
        setGuestData(decoded)

        /* ------------------------------------------- */
        /*  STEP 2: fetch event info and RSVP status   */
        /* ------------------------------------------- */
        return Promise.all([
          axios.get(`${BASE_URL}/guest/event-info/${decoded.a}`),
          axios.get(`${BASE_URL}/guest/rsvp-status/${decoded.p}/${decoded.a}`),
        ])
      })
      .then(([eventResponse, rsvpResponse]) => {
        const eventData = eventResponse.data
        const rsvpData = rsvpResponse.data

        // Process event data
        const [datePart, timePartRaw] = eventData.eventDate.split('T')
        const timePart = timePartRaw.split(':').slice(0, 2).join(':')
        setStartDate(datePart)
        setStartTime(timePart)
        setEventInfo(eventData)
        setHusbandFirstName(eventData.husbandFirstName)
        setWifeFirstName(eventData.wifeFirstName)

        // Process RSVP data
        if (rsvpData.responded) {
          setRsvpStatus(rsvpData.is_coming ? 'yes' : 'no')
          if (rsvpData.is_coming) {
            setConfirmedGuestCount(rsvpData.number_of_guests)
          }
        }
      })
      .catch((err) => {
        console.error('Link invalid or expired:', err)
      })
  }, [id, setHusbandFirstName, setWifeFirstName])

  let wazeLink = '#'
  if (eventInfo && eventInfo.eventLat && eventInfo.eventLng) {
    wazeLink = `https://waze.com/ul?ll=${eventInfo.eventLat},${eventInfo.eventLng}&navigate=yes`
  }

  const handleRSVP = (status) => {
    if (status === 'yes') {
      setShowModal(true) // Open modal to select guest count
    } else {
      updateRSVP(status, 0)
    }
  }

  const updateRSVP = (status, count) => {
    if (!guestData) return

    axios
      .post(`${BASE_URL}/guest/rsvp`, {
        admin_username: guestData.a,
        phone_number: guestData.p,
        does_arrive: status,
        count: count,
      })
      .then((data) => {
        console.log('RSVP updated successfully:', data)
        setRsvpStatus(status)
        setShowModal(false)
        // Store confirmed guest count when status is 'yes'
        if (status === 'yes') {
          setConfirmedGuestCount(count)
        } else {
          setConfirmedGuestCount(0)
        }

        if (status === 'yes') {
          if (eventInfo.organizeTransport) {
            setShowTransport(true)
          } else {
            alert(
              language === 'he'
                              ? 'אישור ההגעה התקבל בהצלחה. במידה ויהיה שינוי, עדיין ניתן ללחוץ על הכפתורים.'

                // ? 'אישור ההגעה התקבל בהצלחה. במידה ויהיה שינוי, עדיין ניתן ללחוץ על הכפתורים. לנוחיותכם, ניתן להעניק מתנות בלחיצה על הכפתור מתנה.'
                // : 'Your attendance confirmation was received successfully. If there are any changes, you can still click the buttons. For your convenience, you can give gifts by clicking the gift button.'
                                : 'Your attendance confirmation was received successfully. If there are any changes, you can still click the buttons.'

            )
          }
        } else {
          // alert(
          //   language === 'he'
          //     ? 'זה בסדר, תודה רבה על העדכון. במידה ויהיה שינוי, עדיין ניתן ללחוץ על הכפתורים. לנוחיותכם, ניתן להעניק מתנות בלחיצה על הכפתור מתנה.'
          //     : "That's okay, thank you for the update. If there are any changes, you can still click the buttons. For your convenience, you can give gifts by clicking the gift button."
          // )
          alert(
            language === 'he'
              ? 'זה בסדר, תודה רבה על העדכון. במידה ויהיה שינוי, עדיין ניתן ללחוץ על הכפתורים.'
              : "That's okay, thank you for the update. If there are any changes, you can still click the buttons."
          )
        }
      })
      .catch((err) => console.error('Error updating RSVP', err))
  }

  if (!guestData || !eventInfo)   return <LoadingComponent />

  return (
    <div className="guest-dashboard">
      {/* Tab Menu */}
      <BottomNav setActiveTab={setActiveTab} activeTab={activeTab} />
      <div className="guest-container">
        {/* RSVP TAB */}

        {activeTab === 'rsvp' && (
          <>



            {/* Show confirmed RSVP status if user has confirmed with 'yes' */}
            {rsvpStatus === 'yes' && confirmedGuestCount > 0 ? (
              <div className="confirmed-rsvp">
                <div className="confirmed-status">
                  <FaCheck
                    className="check-icon"
                    style={{ color: 'green', marginRight: '8px' }}
                  />
                  <span>
                    <T k="confirmedAttendance" /> {confirmedGuestCount}{' '}
                    <T k="people" />
                  </span>
                </div>
                <p>
                  <T k="canChangeChoice" />
                </p>
                <div className="rsvp-buttons">
                  <button onClick={() => handleRSVP('yes')}>
                    <T k="attending" />
                  </button>
                  <button onClick={() => handleRSVP('no')}>
                    <T k="notAttending" />
                  </button>
                </div>
                {eventInfo?.organizeTransport && (
                  <button
                    className="change-transport-btn"
                    onClick={handleChangeTransport}
                  >
                    <T k="changeTransport" />
                  </button>
                )}
              </div>
            ) : (
              /* Show original RSVP buttons */
              <div className="rsvp-buttons">
                <button onClick={() => handleRSVP('yes')}>
                  <T k="attending" />
                </button>
                <button onClick={() => handleRSVP('no')}>
                  <T k="notAttending" />
                </button>
              </div>
            )}

            {eventInfo?.invitationImage && (
              <img
                src={eventInfo.invitationImage}
                alt="Wedding Invitation"
                className="invitation-image"
              />
            )}
            <div className="guest-add-calendar" onClick={handleDivClick}>
              <FaCalendarPlus
                className="calendar-icon"
                fill={'#2c7499'}
                stroke={'#2c7499'}
                size={22}
              />
              <div ref={calendarButtonRef}>
                <AddToCalendarButton
                  name={`האירוע של ${wifeFirstName}`}
                  // name={` חתונה של ${wifeFirstName}&${husbandFirstName}`}
                  options={['Apple', 'Google']}
                  location={eventInfo.eventAddress}
                  label={language === 'he' ? 'הוסף ליומן' : 'Add to Calendar'}
                  startDate={startDate}
                  endDate={startDate}
                  startTime={startTime}
                  endTime="23:59"
                  timeZone="Asia/Jerusalem"
                  className="my-calendar-button"
                  hideIconButton={true}
                  listStyle="modal"
                  lightMode="bodyScheme"
                />
              </div>
            </div>

            {showModal && (
              <div className="modal">
                <IoClose
                  className="close-icon"
                  onClick={() => setShowModal(false)}
                />

                <h3>
                  <T k="howManyGuests" />
                </h3>
                <select
                  value={guestCount}
                  onChange={(e) => setGuestCount(e.target.value)}
                >
                  <option value="1">1</option>
                  <option value="2">2</option>
                  <option value="3">3</option>
                  <option value="4">4</option>
                  <option value="5">5</option>
                  <option value="6">6</option>
                  <option value="7">7</option>
                  <option value="8">8</option>
                </select>
                <button onClick={() => updateRSVP('yes', guestCount)}>
                  <T k="confirmAttendance" />
                </button>
              </div>
            )}
            {showTransport && (
              <div className="modal">
                <IoClose
                  className="close-icon"
                  onClick={() => setShowTransport(false)}
                />

                <h3>
                  <T k="attendanceConfirmed" />
                </h3>
                <p>
                  <T k="transportQuestion" />
                </p>

                <select
                  value={transport}
                  onChange={(e) => setTransport(e.target.value)}
                >
                  <option value="none">
                    <T k="noThanks" />
                  </option>
                  {eventInfo.transportStops.map((stop, i) => (
                    <option key={i} value={stop}>
                      {stop}
                    </option>
                  ))}

                  {/* <option value="tlv">כן, מסבידור מרכז ב18:00</option>
                  <option value="herz">כן, מהרצליה ב18:10</option> */}
                </select>

                <button onClick={handleAddTransport} disabled={saveConfirmed}>
                  <T k="save" />
                </button>

                {saveConfirmed && (
                  <div className="save-confirmation">
                    <FaCheck className="check-icon" />
                    <span>
                      <T k="saved" />
                    </span>
                  </div>
                )}
              </div>
            )}
          </>
        )}

        {/* LOCATION TAB */}
        {activeTab === 'location' &&
          (eventInfo ? (
            <>
              <LocationSection eventInfo={eventInfo} wazeLink={wazeLink} />
            </>
          ) : (
            <div className="inline-loading">
              <div className="loading-spinner"></div>
              <T k="loadingGeneral" />
            </div>
          ))}

        {/* PRESENT TAB */}
        {/* {activeTab === 'present' && (
          <div className="present-section">
            {!showPaymentForm ? (
              <div className="gift-form">
                <div className="gift-header">
                  <h2>
                    <T k="giftTitle" />
                  </h2>
                  <p className="gift-subtitle">
                    <T k="giftSubtitle" />
                  </p>
                </div>

                <div className="gift-input-group">
                  <label htmlFor="gift-amount">
                    <T k="giftAmount" /> *
                  </label>
                  <div className="amount-input-wrapper">
                    <input
                      type="number"
                      id="gift-amount"
                      value={giftAmount}
                      onChange={(e) => setGiftAmount(e.target.value)}
                      placeholder={language === 'he' ? 'הזן סכום' : 'Enter amount'}
                      min="1"
                    />
                    <span className="currency-label">₪</span>
                  </div>
                  {giftAmount && (
                    <div className="fee-info">
                      <small>
                        <T k="processingFee" />: ₪{(parseFloat(giftAmount) * 0.015).toFixed(2)}
                      </small>
                      <div className="total-amount">
                        <T k="total" />: ₪{(parseFloat(giftAmount) * 1.015).toFixed(2)}
                      </div>
                    </div>
                  )}
                </div>

                <div className="gift-input-group">
                  <label htmlFor="gift-message">
                    <T k="giftMessage" /> (<T k="optional" />)
                  </label>
                  <textarea
                    id="gift-message"
                    value={giftMessage}
                    onChange={(e) => setGiftMessage(e.target.value)}
                    placeholder={language === 'he' ? 'כתוב ברכה לזוג...' : 'Write a message to the couple...'}
                    rows="4"
                    maxLength="500"
                  />
                  <small className="char-count">
                    {giftMessage.length}/500
                  </small>
                </div>

                <button 
                  className="proceed-to-payment-btn"
                  onClick={() => setShowPaymentForm(true)}
                  disabled={!giftAmount || parseFloat(giftAmount) <= 0}
                >
                  <T k="proceedToPayment" />
                </button>
              </div>
            ) : (
              <div className="payment-form-container">
                <button 
                  className="back-btn"
                  onClick={() => setShowPaymentForm(false)}
                >
                  ← <T k="back" />
                </button>
                <div className="payment-summary">
                  <h3><T k="paymentSummary" /></h3>
                  <p><T k="amount" />: ₪{giftAmount}</p>
                  <p><T k="processingFee" />: ₪{(parseFloat(giftAmount) * 0.015).toFixed(2)}</p>
                  <p className="total"><T k="total" />: ₪{(parseFloat(giftAmount) * 1.015).toFixed(2)}</p>
                  {giftMessage && (
                    <div className="message-preview">
                      <strong><T k="yourMessage" />:</strong>
                      <p>{giftMessage}</p>
                    </div>
                  )}
                </div>
                <PayMe3DSCheckout 
                  saleDetails={{
                    ...saleInfo,
                    sale_price: Math.round(parseFloat(giftAmount) * 1.015 * 100),
                    product_name: language === 'he' ? 'מתנה לחתונה' : 'Wedding Gift',
                    giftMessage: giftMessage
                  }} 
                />
              </div>
            )}
          </div>
        )} */}
      </div>
    </div>
  )
}

export default GuestDashboard
